module.exports = __webpack_public_path__ + "img/stick_divers_aire_camping_car.f479c9b9.svg";